import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ErrorModal from "./components/base/ErrorModal";

const Home = () => {
  const [error, setError] = useState<string>("");
  const [isErrorModalVisible, setErrorModalVisibility] =
    useState<boolean>(false);
  const [iframes, setIframes] = useState([
    { id: 0, name: "austin_retail.pdf", src: undefined, visible: false },
    {
      id: 1,
      name: "lighthouse_netsuite",
      src: "https://5299110-sb1.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=5417&deploy=1&compid=5299110_SB1&ns-at=AAEJ7tMQwnwAVRUSljm464zGWhfOM8XOFTgA2zCcJT8eDSe2nzg",
      visible: false,
    },
  ]);

  useEffect(() => {
    iframes.forEach((iframe) => {
      if (iframe.src === undefined) {
        generatePresignedUrl(iframe.name); // Fetch src for iframe with undefined src
      }
    });
  }, [iframes]);

  const handleErrorModalVisibility = () => {
    setErrorModalVisibility(!isErrorModalVisible);
  };

  const closeIframe = (iframeId: number) => {
    setIframes((prevIframes) =>
      prevIframes.map((iframe) =>
        iframe.id === iframeId ? { ...iframe, visible: false } : iframe
      )
    );
  };

  const openIframe = (iframeId: number) => {
    setIframes((prevIframes) =>
      prevIframes.map((iframe) =>
        iframe.id === iframeId ? { ...iframe, visible: true } : iframe
      )
    );
  };

  const generatePresignedUrl = async (fileName: string) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_LIGHTHOUSE_SERVICE_DOMAIN}/api/v1/s3/generate-presigned-url`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            file_name: fileName,
          }),
        }
      );

      if (!response.ok) {
        // Attempt to parse the error message if it's available
        const errorData = await response.json();
        setError(errorData.error || "Failed to generate presigned URL");
        throw new Error(errorData.error || "Failed to generate presigned URL");
      }

      const data = await response.json(); // Parse JSON response
      setIframes((prevIframes) =>
        prevIframes.map((iframe) =>
          iframe.name === fileName ? { ...iframe, src: data.url } : iframe
        )
      );
    } catch (tmpError: any) {
      setError(tmpError.message);
    }
  };

  return (
    <Box
      sx={{
        pt: 5,
      }}
    >
      <ErrorModal
        isShown={isErrorModalVisible}
        onClose={handleErrorModalVisibility}
        message={error}
      />
      <List>
        {iframes.map((iframe, index) => (
          <>
            <div key={index} style={{ display: "flex", alignItems: "center" }}>
              <ListItemButton
                sx={{
                  maxWidth: "fit-content",
                  "&:hover": { backgroundColor: "lightgray" },
                }}
                onClick={() => openIframe(iframe.id)}
              >
                <ListItemText
                  primary={iframe.name}
                  sx={{
                    color: "blue",
                  }}
                />
              </ListItemButton>
              <Button
                variant="contained"
                color="primary"
                onClick={() => closeIframe(iframe.id)}
              >
                Close Iframe {iframe.name}
              </Button>
            </div>
            {iframe.visible && (
              <Paper
                sx={{
                  p: 2,
                  margin: "auto",
                  maxWidth: iframe.name === "lighthouse_netsuite" ? 1500 : 900,
                  flexGrow: 1,
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "#1A2027" : "#fff",
                }}
              >
                <Grid container spacing={2} sx={{ textAlign: "center" }}>
                  <Grid size={{ xs: 12 }} container>
                    <Grid container direction="column" spacing={2}>
                      <Grid>
                        <iframe
                          title={iframe.name}
                          src={iframe.src}
                          style={{
                            width:
                              iframe.name === "lighthouse_netsuite"
                                ? 1500
                                : 900,
                            height: "800px",
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            )}
          </>
        ))}
      </List>
    </Box>
  );
};

export default Home;
